import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DataAcaoJudicialModel } from '../../shared/models/data-acao-judicial.model';
import { IrFracaoPatrimonialObeterAnosModel as IrFracaoPatrimonialObterAnosModel } from '../../shared/models/ir-fracao-patrimonial-obter-anos.model';
import { PessoaDadosSimplicadosModel } from '../../shared/models/pessoa-simplificada.model';
import { PessoaService } from '../../shared/services/pessoa.service';
import { IrPatrimonialPdf } from './../../shared/services/documentos-pdf-imprimir/financeiro/ir-patrimonial/ir-patrimonial-pdf';
import { IrFracaoPatrimonialService } from './service/ir-fracao-patrimonial.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';

@Component({
  selector: 'app-ir-fracao-patrimonial',
  templateUrl: './ir-fracao-patrimonial.component.html',
  styleUrls: ['./ir-fracao-patrimonial.component.css']
})
export class IrFracaoPatrimonialComponent implements OnInit {

  componentes: any[] = [1];

  param: string;

  @BlockUI() blockUi: NgBlockUI;


  // cdCentrus: 23868;
  // 20087 --- 9170190  --- SILVIO RODRIGUES ALVES
  cdCentrus: number;

  processoFormatadoTela: string;

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  dataAcaoJudicialModel: DataAcaoJudicialModel = new DataAcaoJudicialModel();

  irFracaoPatrimonialObterAnosModel: Array<IrFracaoPatrimonialObterAnosModel> = new Array<IrFracaoPatrimonialObterAnosModel>();
  vlFracaoTotal = 0;
  vlIrrfTotal = 0;
  sindicato: any;

  constructor(
    private irFracaoPatrimonialService: IrFracaoPatrimonialService,
    private pessoaService: PessoaService,
    private authInterceptor: AuthInterceptor,
    private irPatrimonialPdf: IrPatrimonialPdf,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();

  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuFinanceiro';
        }
        this.getPessoasDadosSimplificado();
      })
  }




  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getConsultaAcao();
      this.getObterTotAno();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }




  async getObterTotAno() {
    try {

      const irFracaoPatrimonialObeterAnosLista = await this.irFracaoPatrimonialService.getObterTotAno(this.cdCentrus)

      if (irFracaoPatrimonialObeterAnosLista.length === 0) {
        return this.voltarForcada();
      }

      this.irFracaoPatrimonialObterAnosModel = irFracaoPatrimonialObeterAnosLista;
      irFracaoPatrimonialObeterAnosLista.map(item => {
        this.vlFracaoTotal += item.vlFracao;
        this.vlIrrfTotal += item.vlIrrf;
      })
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getConsultaAcao() {
    this.blockUi.start();

    try {
      const DataAcaoJudicial = await this.irFracaoPatrimonialService.getConsultaAcao(this.cdCentrus)

      this.dataAcaoJudicialModel = DataAcaoJudicial;



      (this.dataAcaoJudicialModel.nrProc3 === '154' || this.dataAcaoJudicialModel.nrProc3 === '3413')
        || (this.dataAcaoJudicialModel.nrProc3 === '146') ? this.sindicato = 'SINDSEP' : this.sindicato = 'SINAL';

      this.processoFormatadoTela = `${this.dataAcaoJudicialModel.nrAnoProc}.${this.dataAcaoJudicialModel.nrProc1}
      .0${this.dataAcaoJudicialModel.nrProc2}.000${this.dataAcaoJudicialModel.nrProc3}-${this.dataAcaoJudicialModel.dvProc}
      ${this.dataAcaoJudicialModel.dsVara}de ${this.dataAcaoJudicialModel.dtAcaoJudicial} (${this.sindicato})`
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    } finally {
      this.blockUi.stop();
    }
  }

  direcionar(aaReferencia: number): void {
    this.router.navigate(['/financeiros/irFracaoPatrimonial/irFacaoPat/Detalhe/', aaReferencia], { skipLocationChange: true })
  }


  imprimirPagina() {
    this.irPatrimonialPdf.funcionarios(this.pessoaDadosSimplicadosModel,
      this.vlFracaoTotal, this.vlIrrfTotal, this.irFracaoPatrimonialObterAnosModel,
      this._formatarImpressao());
  }

  private _formatarImpressao(): string {
    let processoFomart = ''
    processoFomart = (this.dataAcaoJudicialModel.nrAnoProc + '.' + this.dataAcaoJudicialModel.nrProc1
      + '.0' + this.dataAcaoJudicialModel.nrProc2 + '.000' + this.dataAcaoJudicialModel.nrProc3 + '-' + this.dataAcaoJudicialModel.dvProc + `   ` +
      this.dataAcaoJudicialModel.dsVara.trim() + `  de  ` + this.dataAcaoJudicialModel.dtAcaoJudicial + ' (' + this.sindicato + ')');
    return processoFomart;
  }


  voltarForcada(): void {
    this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/ir-fracao-patrimonial/ir-fracao-patrimonial.component.ts